import * as THREE from "three";
import {
  BLACK_HOLE_SCENE_INDEX,
  SCENE_DURATION,
  TOTAL_SCENES,
} from "../constants/sceneConfig";

const duration = SCENE_DURATION.toFixed(1);
const totalScenes = TOTAL_SCENES.toFixed(1);
const blackHoleScene = BLACK_HOLE_SCENE_INDEX.toFixed(1);

export const BlackHoleParticleShader = {
  uniforms: { time: { value: 0.0 } },
  vertexShader: `
    uniform float time;
    attribute vec3 initialPos;
    attribute float aRandom;
    varying float vAlpha;
    varying vec3 vColor;

    void main() {
        float duration = ${duration};
        float totalScenes = ${totalScenes};
        float globalTime = time;
        float sceneIdx = floor(mod(globalTime / duration, totalScenes));
        
        float isActive = step(${blackHoleScene}-0.5, sceneIdx) * step(sceneIdx, ${blackHoleScene}+0.5);
        
        float localTime = mod(globalTime, duration);
        float fadeIn = smoothstep(0.0, 1.0, localTime);
        float fadeOut = smoothstep(duration, duration - 1.0, localTime);
        vAlpha = isActive * fadeIn * fadeOut;

        if (vAlpha < 0.01) {
            gl_Position = vec4(0.0);
            gl_PointSize = 0.0;
            return;
        }

        vec3 pos = initialPos;
        
        float t = time * 2.0 + aRandom * 30.0;
        
        float startRadius = length(pos.xz);
        float r = mod(startRadius - t, 15.0); 
        
        r = max(r, 0.1);
        
        float angle = atan(pos.z, pos.x);
        angle += 5.0 / (r + 0.1);
        
        float nx = cos(angle) * r;
        float nz = sin(angle) * r;
        
        float ny = -2.0 - 1.5 / (r * 0.8);
        
        vec4 mvPosition = modelViewMatrix * vec4(nx, ny, nz, 1.0);
        gl_Position = projectionMatrix * mvPosition;
        
        gl_PointSize = (300.0 / -mvPosition.z) * max(0.1, r * 0.15);

        vColor = mix(vec3(1.0, 0.6, 0.2), vec3(0.1, 0.2, 0.8), smoothstep(0.0, 10.0, r));
    }
  `,
  fragmentShader: `
    varying float vAlpha;
    varying vec3 vColor;
    void main() {
        if (vAlpha < 0.01) discard;
        vec2 coord = gl_PointCoord - vec2(0.5);
        float dist = length(coord);
        if (dist > 0.5) discard;
        float glow = 1.0 - (dist * 2.0);
        gl_FragColor = vec4(vColor, vAlpha * glow * glow);
    }
  `,
  transparent: true,
  depthWrite: false,
  blending: THREE.AdditiveBlending,
};
